import { AdminDashboardContentStaticsResponse, AdminDashboardDataFilter } from '../../graphql/API';
import { adminGetDashboardContentData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardContentDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardContentStaticsResponse> => {
  const result = await executeGql(adminGetDashboardContentData, { filter });
  return processGqlResult<AdminDashboardContentStaticsResponse>(
    'adminGetDashboardContentData',
    result,
  );
};
